import ChartComponent from './components/Chart.vue';

const Chart = {
    install(Vue) {
        Vue.component('chart', ChartComponent);
    },
};
export default Chart;

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Chart);
}
